"use strict";
// src/ts/static.assets.ts
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.StaticAssets = void 0;
var logo_svg_1 = __importDefault(require("./../images/logo.svg"));
var logo_mobile_svg_1 = __importDefault(require("./../images/logo-mobile.svg"));
var StaticAssets = /** @class */ (function () {
    function StaticAssets() {
    }
    StaticAssets.prototype.run = function () {
        return [
            logo_svg_1["default"],
            logo_mobile_svg_1["default"],
        ];
    };
    return StaticAssets;
}());
exports.StaticAssets = StaticAssets;
